import React, { useState } from "react";
import { Dropdown } from "antd";
import { useSelector } from "react-redux";
import { css } from "@emotion/css";
import PeopleIcon from "../../../../Theme/CustomIcons/Icons/Users/PeopleIcon";
import ActiveUsers from "../OrgSettings/Users/DropdownOptions/ActiveUsers";
import Contacts from "../OrgSettings/Users/DropdownOptions/Contacts";
import GuestUsers from "../OrgSettings/Users/DropdownOptions/GuestUsers";
import DeletedUsers from "../OrgSettings/Users/DropdownOptions/DeletedUsers";

const userMenuItems = [
  {
    key: "ActiveUsers",
    label: "Active Users",
    value: "ActiveUsers",
    children: <ActiveUsers />,
  },
  {
    key: "Contacts",
    label: "Contacts",
    value: "Contacts",
    children: <Contacts />,
  },
  {
    key: "GuestUsers",
    label: "Guest Users",
    value: "GuestUsers",
    children: <GuestUsers />,
  },
  {
    key: "DeletedUsers",
    label: "Deleted Users",
    value: "DeletedUsers",
    children: <DeletedUsers />,
  },
];

export const getSelectedUserComponent = (selectedUserType) => {
  const selectedUser = userMenuItems.find(
    (item) => item.value === selectedUserType
  );
  return selectedUser ? selectedUser.children : <ActiveUsers />;
};

const UsersDropdown = ({
  selectedSetting,
  setSelectedSetting,
  selectedUserType,
  setSelectedUserType,
}) => {
  const themeDefault = useSelector((state) => state.themeDefault);
  const [dropdownOpen, setDropdownOpen] = useState(false);

  const handleMenuClick = ({ key }) => {
    setSelectedUserType(key);
    setSelectedSetting("Users");
    setDropdownOpen(false); // Close dropdown after selection
  };

  const handleOpenChange = (open) => {
    // Only open dropdown if Users is selected
    if (open && selectedSetting === "Users") {
      setDropdownOpen(true);
    } else {
      setDropdownOpen(false);
    }
  };

  const handleUsersClick = () => {
    if (selectedSetting === "Users") {
      // If Users is already selected, toggle dropdown
      setDropdownOpen(!dropdownOpen);
    } else {
      // If Users is not selected, select it and open dropdown
      setSelectedSetting("Users");
      setDropdownOpen(true);
    }
  };

  const userMenu = {
    items: userMenuItems.map((item) => ({
      key: item.value,
      label: item.label,
    })),
    onClick: handleMenuClick,
  };

  return (
    <Dropdown
      menu={userMenu}
      trigger={["click"]}
      placement="bottomLeft"
      open={dropdownOpen}
      onOpenChange={handleOpenChange}
      dropdownRender={(menu) => (
        <div
          className={css`
            border-radius: ${themeDefault?.info?.borderRadius || 8}px;

            min-width: 200px;
          `}
        >
          {menu}
        </div>
      )}
    >
      <p
        className={css`
          padding: 10px 12px;
          width: 100%;
          cursor: pointer;
          display: flex;
          align-items: center;
          justify-content: flex-start;
          gap: 10px;
          font-size: ${themeDefault?.info?.newConfig?.titleFontSize};
          border-radius: ${themeDefault?.info?.borderRadius}px;
          background: ${selectedSetting === "Users"
            ? themeDefault?.info?.colorPrimary
            : "transparent"};
          color: ${selectedSetting === "Users"
            ? themeDefault?.info?.newConfig?.components?.Button?.primaryColor ||
              "white"
            : "inherit"};
          line-height: 1;
        `}
        onClick={handleUsersClick}
      >
        <span
          className={css`
            display: flex;
            align-items: center;
            justify-content: center;
            width: 18px;
            height: 18px;
            flex-shrink: 0;
            svg {
              display: block;
              width: 100%;
              height: 100%;
            }
          `}
        >
          <PeopleIcon size="small" />
        </span>
        <span
          className={css`
            display: flex;
            align-items: center;
            line-height: 1;
          `}
        >
          Users
        </span>
      </p>
    </Dropdown>
  );
};

export default UsersDropdown;
